import React, { useEffect, useState} from 'react'
import styles from './StatsPanel.module.scss'
import PieChart from '../../molecules/pieChart/pieChart'
import Heading from '../../atoms/heading/Heading'
import getStateNode from '../../../helpers/getStateNode'

const StatsPanel = (props) => {
  
    const { masterFile, selectedState } = props

    const [totalSchools, setTotalSchools] = useState()
    const [totalPrimary, setTotalPrimary] = useState()
    const [totalEcce, setTotalEcce] = useState()
    const [totalJSS, setTotalJSS] = useState()
    const [totalNewPrimary, setTotalNewPrimary] = useState()
    const [totalNewPrimaryMin100, setTotalNewPrimaryMin100] = useState()
    

    const statsTitle = (selectedState==='National') ? `National Statistics` : `${selectedState} statistics`

    useEffect(() => {
        if (masterFile!==undefined) {
            const stateNode = getStateNode(masterFile, `${selectedState.toLowerCase()}`)
            if(stateNode){
                setTotalSchools(stateNode.totalSchools)
                setTotalPrimary(stateNode.totalPrimary)
                setTotalEcce(stateNode.totalECCE)
                setTotalJSS(stateNode.totalJSS)
                setTotalNewPrimary(stateNode.totalNewPrimary)
                setTotalNewPrimaryMin100(stateNode.totalNewPrimaryMin100)
            }
        }
        
        // eslint-disable-next-line
      }, [masterFile, selectedState]);

    const data = [
            {
              "id": "Primary Schools",
              "label": "Primary Schools",
              "value": totalPrimary,
              "color": "hsl(160, 70%, 50%)"
            },
            {
              "id": "ECCE",
              "label": "ECCE",
              "value": totalEcce,
              "color": "hsl(109, 70%, 50%)"
            },
            {
              "id": "JSS",
              "label": "JSS",
              "value": totalJSS,
              "color": "hsl(120, 70%, 50%)"
            }
    ]
  
    return (
        <div className={styles.outer} >
            <Heading size={4} type={4} noMargin={true}>{statsTitle}</Heading>
            <h6>These statistics are updated for the data selected</h6 >
            <div className={styles.highlight}>
                <div className={styles.textBlock}>
                    <span className={styles.statText}>Total School sites (different types can share the same site):</span>
                    <span className={styles.statResult}>{totalSchools}</span>
                </div>
				<div className={styles.textBlock}>
                    <span className={styles.statText}>Primary:</span>
                    <span className={styles.statResult}>{totalPrimary}</span>
                </div>
                <div className={styles.textBlock}>
                    <span className={styles.statText}>ECCE:</span>
                    <span className={styles.statResult}>{totalEcce}</span>
                </div>
                <div className={styles.textBlock}>
                    <span className={styles.statText}>JSS:</span>
                    <span className={styles.statResult}>{totalJSS}</span>
                </div>
                <div className={styles.textBlock}>
                    <span className={styles.statText}>Proposed Primary Schools:</span>
                    <span className={styles.statResult}>{totalNewPrimary}</span>
                </div>
                <div className={styles.textBlock}>
                    <span className={styles.statText}>Total Number of proposed Primary Schools serving 100+ pupils:</span>
                    <span className={styles.statResult}>{totalNewPrimaryMin100}</span>
                </div>
            </div>
            <div className={styles.chartWrapper}>
                <Heading size={6} type={6} noMargin={true}>Number of Schools by type</Heading> 
                <PieChart data={data} />
                
            </div>
        </div>
    );
}

export default StatsPanel
